export default "__VITE_ASSET__ba46d51f__"